import React from "react";
import { useState } from "react";
import Styles from "../../Styles/Resume.module.css"
import edit from "../../Assets/edit.png"
import del from "../../Assets/delete.png";
import add from "../../Assets/add.png";


const Experience = () => {
    const [workExperience, setWorkExperience] = useState([
      {
        title: 'Front-end Developer',
        company: 'Cdlp Hub Ltd',
        startDate: 'August 2022',
        endDate: 'Present',
        description: 'Responsible for leading the design process, conducting user research, creating wireframes and prototypes, and collaborating with stakeholders to ensure that the design meets the needs of the target audience.',
      },
    ]);
  
    const [newWorkExperience, setNewWorkExperience] = useState({
      title: '',
      company: '',
      startDate: '',
      endDate: '',
      description: '',
    });
  
    const handleAddWorkExperience = () => {
      setWorkExperience([...workExperience, newWorkExperience]);
      setNewWorkExperience({
        title: '',
        company: '',
        startDate: '',
        endDate: '',
        description: '',
      });
    };
  
    const handleEditWorkExperience = (index) => {
      const updatedWorkExperience = [...workExperience];
      updatedWorkExperience[index] = newWorkExperience;
      setWorkExperience(updatedWorkExperience);
    };
  
    const handleDeleteWorkExperience = (index) => {
      const updatedWorkExperience = [...workExperience];
      updatedWorkExperience.splice(index, 1);
      setWorkExperience(updatedWorkExperience);
    };

    const [modalOpen,  setModalOpen  ] = useState(false)

    const handleCloseModal = () => {
      setModalOpen(false);
    };
   
   
  
    return (
      <div className={Styles.contents2}>
        {workExperience.map((experience, index) => (
             <><div key={index} className={Styles.subcontent}>
            <div className={Styles.subcontent1}>
              <h1>Work Experience</h1>
            </div>
            <div className={Styles.subcontent2}>
              <img src={add} onClick={() => setModalOpen(true)} alt="/" width="23.0px" height="23.0px" />
            </div>
          </div><div className={Styles.subcontent01}>
              <hr style={{ width: "605px" }}></hr>  
            </div><div className={Styles.subcontent02}>
              <div className={Styles.subcontent1}>
                <div className={Styles.text}>
                  <div className={Styles.headertext}>
                    <h1 style={{ whiteSpace: "nowrap" }}>{experience.title}</h1>
                    <div className={Styles.icon} style={{ whiteSpace: "nowrap" }}>
                      <img src={edit} alt="/" width="23.0px" height="23.0px" style={{ position: 'relative', right: "30px" }} onClick={() => handleEditWorkExperience()} />
                      <img src={del} alt="/" width="20.0px" height="20.0px" onClick={() => handleDeleteWorkExperience(index)} />
                    </div>
                  </div>
                  <p>{experience.company}</p>
                  <p>{experience.startDate} to {experience.endDate}</p>
                  <p>{experience.description}</p>
                </div>
              </div>
            </div></>
              ))}

      {modalOpen && <div id={Styles.ModalContainer} >
        <div id={Styles.Modal}  >
        <label>Job Title</label>
          <input type="text" value={newWorkExperience.title} onChange={(e) => setNewWorkExperience({ ...newWorkExperience, title: e.target.value })} />
          <label>Company</label>
          <input type="text" value={newWorkExperience.company} onChange={(e) => setNewWorkExperience({ ...newWorkExperience, company: e.target.value })} />
          <label>StartDate</label>
          <input type="text" value={newWorkExperience.startDate} onChange={(e) => setNewWorkExperience({ ...newWorkExperience, startDate: e.target.value })} />
          <label>EndDate</label>
          <input type="text" value={newWorkExperience.endDate} onChange={(e) => setNewWorkExperience({ ...newWorkExperience, endDate: e.target.value })} />
          <label>Description</label>
          <input type="text" value={newWorkExperience.description} onChange={(e) => setNewWorkExperience({ ...newWorkExperience, description: e.target.value })} />
          <button onClick={handleAddWorkExperience} className={Styles.btn1}>Add</button>
            <button onClick={handleCloseModal} className={Styles.btn2}>close</button>
        </div>
        </div>}
            </div>
    );
  }
export default Experience;